import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 border-b border-background-200 pb-5 md:mb-9 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-price-tag-3-line" aria-hidden="true" />
          </span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}